
import moment from 'moment'
import { Component } from 'react'
import { MdPause, MdPlayArrow } from 'react-icons/md'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { withDiscardDialog } from '../../../lib/global-discard-dialog'
import { pause, resume } from '../../Encounter/actions'
import { FloatingActionButton, CircularProgress } from '../../shared/NarusMaterial'

import './styles'

const ONE_HOUR = 60 * 60

const formattedSeconds = sec => {
  const hours = Math.floor(sec / ONE_HOUR)
  const minutes = Math.floor((sec % ONE_HOUR) / 60).toString().padStart(2, 0)
  const seconds = (sec % 60).toString().padStart(2, 0)

  return `${hours === 0 ? '' : `${hours}:`}${minutes}:${seconds}`
}

const calculateEncounterDuration = (statusHistory, status) => {
  if (!statusHistory) {
    return 0
  }

  const now = moment()

  return statusHistory
    .filter(sh => sh.status === status)
    .map(sh => {
      const { start, end: maybeEnd } = sh.period
      const end = maybeEnd ? moment(maybeEnd) : now

      return Math.max(0, Math.floor(end.diff(start) / 1000))
    })
    .reduce((total, number) => total + number)
}

class TimerComponent extends Component {
  render () {
    const { time, onClick, paused, discardDialog } = this.props

    const seconds = formattedSeconds(time || 0)

    return (
      <div className='nh-timer-wrapper'>
        <div
          className='nh-timer'
          style={{ width: `${seconds.length * 12}px`, textAlign: 'left' }}
          title='Encounter Duration'
        >
          {formattedSeconds(time || 0)}
        </div>
        <FloatingActionButton onClick={() => discardDialog.show(undefined, onClick)}>
          <div title={!paused ? 'Pause Encounter' : 'Resume Encounter'}>
            {!paused && (
              <MdPause fill='#ffffff' />
            ) }

            {paused && (
              <MdPlayArrow />
            )}
          </div>
        </FloatingActionButton>
      </div>
    )
  }
}

const Timer = withDiscardDialog(TimerComponent)

class AssessmentTimer extends Component {
  constructor (props) {
    super(props)
    this.handleOnClick = this.handleOnClick.bind(this)
  }

  UNSAFE_componentWillMount () {
    this.intervalHandler = setInterval(() => this.forceUpdate(), 1000)
  }

  componentWillUnmount () {
    clearInterval(this.intervalHandler)
    this.intervalHandler = null
  }

  handleStartClick = () => {
    const { encounter, patientId, resume: propResume } = this.props
      if (encounter?.encounter?.document?.context_id) {
      propResume(patientId, encounter?.encounter?.document?.context_id)
    }
  }

  handleStopClick = () => {
    const { encounter, patientId, pause: propPause } = this.props
    propPause(patientId, encounter?.encounter?.document?.context_id)
  }

  handleOnClick = () => {
    const { encounter } = this.props
    if (encounter?.encounter?.status === 'in-progress') {
      this.handleStopClick()
    } else {
      this.handleStartClick()
    }
  }

  render () {
    const { encounter } = this.props

    if (!encounter || encounter.timerLoading) {
      return (
        <div style={{ width: '36px', height: '36px' }}>
          <CircularProgress type='small' />
        </div>
      )
    }
    return (
      <Timer
        time={calculateEncounterDuration(
          encounter?.encounter?.statusHistory,
          'in-progress'
        )}
        onClick={this.handleOnClick}
        paused={encounter?.encounter?.status === 'onleave'}
      />
    )
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      pause,
      resume
    },
    dispatch
  )

const mapStateToProps = redux => ({
  encounter: redux.encounter,
  patientId: redux.globalVars.params?.id,
  user: redux.auth
})

export default connect(mapStateToProps, mapDispatchToProps)(AssessmentTimer)
